var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroCardIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#CEF4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 46L49.648 38.352C49.8731 38.1272 49.9997 37.8222 50 37.504V27C50 26.2044 49.6839 25.4413 49.1213 24.8787C48.5587 24.3161 47.7956 24 47 24V24C46.2044 24 45.4413 24.3161 44.8787 24.8787C44.3161 25.4413 44 26.2044 44 27V36",
    stroke: "#0CC6D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38L43.716 36.284C43.8062 36.194 43.8776 36.087 43.9264 35.9693C43.9751 35.8516 44.0001 35.7254 44 35.598C43.9997 35.4182 43.9494 35.2419 43.8548 35.089C43.7601 34.9361 43.6248 34.8125 43.464 34.732L42.578 34.29C41.8274 33.9147 40.9777 33.785 40.1493 33.9192C39.3209 34.0535 38.5557 34.4449 37.962 35.038L36.172 36.828C35.4218 37.578 35.0002 38.5952 35 39.656V46M18 46L10.352 38.352C10.1269 38.1272 10.0003 37.8222 10 37.504V27C10 26.2044 10.3161 25.4413 10.8787 24.8787C11.4413 24.3161 12.2044 24 13 24V24C13.7956 24 14.5587 24.3161 15.1213 24.8787C15.6839 25.4413 16 26.2044 16 27V36",
    stroke: "#0CC6D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 38L16.284 36.284C16.1939 36.1939 16.1225 36.087 16.0738 35.9692C16.025 35.8515 16 35.7254 16 35.598V35.598C16 35.232 16.208 34.898 16.536 34.732L17.422 34.29C18.1726 33.9147 19.0223 33.785 19.8507 33.9192C20.6791 34.0535 21.4443 34.4449 22.038 35.038L23.828 36.828C24.5782 37.578 24.9998 38.5952 25 39.656V46M33.334 30H26.666V25.334H22V18.666H26.666V14H33.334V18.666H38V25.334H33.334V30V30Z",
    stroke: "#0CC6D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCardIcon3);
export default __webpack_public_path__ + "static/media/HeroCardIcon3.8289f48ded1daea6d81416cf8d547378.svg";
export { ForwardRef as ReactComponent };